module.exports = __webpack_public_path__ + "static/media/task.e1bc540a.png";